import React from 'react';
import { Box, Flex, Icon } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';

import Button from '@/components/Button';
import Heading from '@/components/Heading';
import Text from '@/components/Text';
import MessageFormModal from './components/MessageFormModal';

const SendMessage = React.memo(() => (
  <Flex alignItems="flex-start">
    <Box>
      <Icon name="email" size={[22, null, 36]} />
    </Box>
    <Flex ml="2" pt={[null, null, 2]} flexDirection="column">
      <Heading.h4>Send message via a form</Heading.h4>
      <Text mt="2">
        The Jetstar Holidays team aims to deliver an outstanding customer
        experience, so your feedback - good or bad - is very important to us.
      </Text>
      <Flex>
        <ToggleContent
          toggle={(open) => (
            <Button mt="4" dialogue data-testid="SEND-MESSAGE" onClick={open}>
              Send message
            </Button>
          )}
          content={(close) => <MessageFormModal onClose={close} />}
        />
      </Flex>
    </Flex>
  </Flex>
));

export default SendMessage;
